// Singleton ref exposing the header search bar to any component that
// needs to control it synchronously inside a user gesture handler.
//
// Why a singleton (vs. React context or window events):
//   Mobile browsers (iOS Safari, Android Chrome) require `.focus()`
//   on a text input to be called SYNCHRONOUSLY inside the user
//   gesture (click / touch) handler in order to open the on-screen
//   keyboard. Any deferral through `setTimeout`, `requestAnimationFrame`,
//   a `useEffect`, or a `CustomEvent` dispatched through the event
//   loop breaks the gesture chain and suppresses the keyboard — even
//   though focus itself still happens.
//
//   To keep the call synchronous we can't rely on React state updates
//   (which schedule a re-render on the next tick) OR window events
//   (whose listeners run in a separate microtask). Instead we expose
//   a plain object with method properties. Header populates them on
//   mount; Home invokes them directly inside the click handler. No
//   context, no re-renders, no timing games.
//
//   `focusNow()` — imperatively un-hides the mobile search wrapper,
//     clears the input's DOM value, calls `input.focus()` synchronously
//     (mobile keyboard pops up), and positions the caret at 0. Then
//     Header's React state catches up on the next tick.
//   `collapseNow()` — pure mobile-bar collapse. Returns the header
//     to its icon-only state on mobile. Preserves the query text
//     and URL `?q=` so intra-Home tab switches can restore the
//     previous search when the user returns to the Search tab.
//   `resetNow()` — full reset: collapseNow + clear input + strip
//     `?q=` from the URL. Used when navigating AWAY from Home
//     entirely (sidebar item, external link, etc.).
export const searchFocusRef = { focusNow: null, collapseNow: null, resetNow: null };

